import { render, staticRenderFns } from "./PortfolioStockList.vue?vue&type=template&id=2deb5ab3&scoped=true&"
import script from "./PortfolioStockList.vue?vue&type=script&lang=js&"
export * from "./PortfolioStockList.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStockList.vue?vue&type=style&index=0&id=2deb5ab3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb5ab3",
  null
  
)

export default component.exports